import { render } from "./NewPaymentMethod.vue?vue&type=template&id=336b7953"
import script from "./NewPaymentMethod.vue?vue&type=script&lang=js"
export * from "./NewPaymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__